// extracted by mini-css-extract-plugin
export default {"customer-logo":"customers_customer-logo__IGfDz","swiper":"customers_swiper__Y4V88","titl":"customers_titl__furV0"};